import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal as AntModal, Input, Popover, Checkbox, Button } from "antd";
import SettingIconDark from "../../assets/images/svg/SettingIconDark.svg";
import AwsServerService from "../../common/util/AwsServerService";
import { Row, Col} from "reactstrap";
import swal from "sweetalert";
import { faClone } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomBar from "../../components/ProjectTasks/BottomBar";
import { convertToUSTime } from "../../components/HR/TimeClock/Util";
import moment from "moment";

const RenderSettingsPopoverContent = ({
  taskModalState,
  taskData,
  setTaskData,
  taskEmptyTemplate,
  setPageRefreshData,
  setOpen,
  selectedTable,
  item,
  module,
  count,
  setSelectedIds,
  DealName,
  dealSelected
}
) => {
  const defaultDuplicateObject = {
    TaskName: "",
    Everything: true,
    // Attachements: true, Comments: true, InputFields: true,LookUpFields: true, Dependencies: true,
    StartDate: true,
    DueDate: true,
    Assignee: true,
    Supervisor: true,
    TimeEstimate: true,
    Priority: true,
    // Status: true,
    Subtask: true,
  };

  const settingsOptions = [
    { label: "Duplicate Task", value: "Duplicate" },
    { label: "Save as Template", value: "Template" },
    { label: "Copy Link", value: "Link" },
    { label: "Add Relative Path", value: "Path" },
  ];
  const userInfo = JSON.parse(localStorage.getItem('userinfo'));

  const getLinkOfTaskModal = (parent) => {
    if (parent.TaskId) {
      // Use window.location.origin for the full base URL
      const locationUrl = window.location.origin;
      // Combine pathname and hash to include the full path
      const pathName = window.location.pathname + window.location.hash;
      // Construct the complete URL
      const link = `${locationUrl}${pathName}`;
      // Copy the constructed URL to the clipboard
      navigator.clipboard.writeText(link);
      // console.log("Copied Link:", link);
    }
  };

  const [popoverVisible, setPopoverVisible] = useState(false);
  const [duplicateValueObj, setDuplicateValueObj] = useState({
    ...defaultDuplicateObject,
  });
  const [duplicatePopUp, setDuplicatePopUp] = useState(false);
  const [popUpType, setPopUpType] = useState(null);

  const handleOptionSelect = (option) => {
     ;
    console.log("Option Value:- ", option);
    setPopUpType(option.value);
    const parent = { ...taskData };
    const duplicateObject = { ...duplicateValueObj };
    if (option && option.value == "Duplicate") {
      let duplicate = {
        TaskName: "",
        Everything: true,
        // Attachements: true, Checklist: true, Comments: true, InputFields: true,
        // LookUpFields: true, Dependencies: true,
        StartDate: true,
        DueDate: true,
        Assignee: true,
        Supervisor: true,
        TimeEstimate: true,
        Priority: true,
        // Status: true,
        Subtask: true,
      };
      duplicate.TaskName = parent.TaskName + " - Copy";
      console.log("duplicate valueObj:- ", duplicate);
      setDuplicateValueObj(duplicate);
      setDuplicatePopUp(true);
    }
    if (option && option.value == "Template") {
      // setTemplatePopUp(true)
      // setServiceRequested(serviceReqVariable);
      duplicateObject.TaskName = parent.TaskName + " - Template";
      setDuplicateValueObj(duplicateObject);
      setDuplicatePopUp(true);
    }
    if (option && option.value == "Link") {
      getLinkOfTaskModal(parent);
    }
    if (option && option.value == "Path") {
      // setRelativeModal(true);
    }

    console.log(`Selected option: ${option.value}`);

    setPopoverVisible(false); // Close popover after selection
    // Add your handling logic here
  };

  const renderSettingsPopoverContent = () => (
    <div>
      {taskModalState.action !== "create" &&
        settingsOptions.map((option) => (
          <Button
            key={option.value}
            style={{ width: "100%" }}
            className="Duplicate-modal-btns"
            onClick={(e) => {
              if (taskModalState.action === "create") {
                e.preventDefault();
                return;
              }
              handleOptionSelect(option);
            }}
          >
            {option.label}
          </Button>
        ))}
    </div>
  );
const [indeterminate, setIndeterminate] = useState(false);
      const hanleCreateDuplicateTask = async(duplicateFields, data) =>{
        let duplicateObj = { ...duplicateFields };
        let duplicateTaskObj = { ...data };
        if (!duplicateObj.Priority || duplicateObj.Priority == "" || duplicateObj.Priority == null || duplicateObj.Priority == undefined) {
          duplicateTaskObj.Priority = "Not Set"
        }
        if (!duplicateObj.Assignee) {
          duplicateTaskObj.Assignee = '';
        }
        if (!duplicateObj.DueDate) {
          duplicateTaskObj.DueDate = new Date();
        }
        if (!duplicateObj.Supervisor) {
          duplicateTaskObj.Supervisor = ''
        }
        if (!duplicateObj.StartDate) {
         duplicateTaskObj.StartDate = new Date()
        }
    
        if(!duplicateTaskObj.TaskFlowId && duplicateTaskObj.TaskFlowObject){
            duplicateTaskObj.TaskFlowId = duplicateTaskObj?.TaskFlowObject?.ROWID
        }
    
          delete duplicateTaskObj?.TaskROWID
          delete duplicateTaskObj?.SubTasks
          delete duplicateTaskObj?.TaskTemplateId
          delete duplicateTaskObj?.TaskId
          delete duplicateTaskObj?.MilestoneName
          delete duplicateTaskObj?.IsMilestone
          delete duplicateTaskObj?.deps
          delete duplicateTaskObj?.Edges
          delete duplicateTaskObj?.Nodes
          delete duplicateTaskObj?.TaskStatusText
          delete duplicateTaskObj?.TaskStatus

          duplicateTaskObj.TaskFlowObject.Nodes = 
            duplicateTaskObj.TaskFlowObject.Nodes.filter((node) => node?.data?.label === "Not Started");
          duplicateTaskObj.TaskStatus = duplicateTaskObj.TaskFlowObject.Nodes[0].id;
          duplicateTaskObj.TaskName = duplicateValueObj?.TaskName
          duplicateTaskObj["Status_Time"] =  moment.utc().format('YYYY-MM-DD HH:mm:ss');
          const TaskApiToCall =
            popUpType === "Duplicate" && selectedTable == "tasks"
                ? AwsServerService.saveTask
                : AwsServerService.saveTaskInTemplate;
    
                const SubTaskApiToCall =
                popUpType === "Duplicate" && selectedTable == "tasks"
                    ? AwsServerService.createSubtask
                    : AwsServerService.createSubtaskInTemplate;
    
          await TaskApiToCall(duplicateTaskObj).then(async res=>{
            // if(popUpType === "Duplicate" && selectedTable == "tasks"){
        //       let nextNode = duplicateTaskObj.TaskFlowObject?.Nodes?.filter(res => res.id == "1")[0];
        //       let StatusTimelineEdgePayload = {
        //   CREATEDBY: userInfo?.email_id,
        //   TaskStatus: {data:{label: "Created", color: "#108ee9"},
        //               label : "Task Created",
        //               source : "0",
        //               target : "1",
        //               type : "custom-edge"},
        //   TaskROWID: res[0]?.insertId,
        //   TaskType: "Task",
        //   IsTransition: 1,
        //   UTCTimeString: convertToUSTime(new Date()),
        //   Comment: ""
        // }
        // let StatusTimelinePayload = {
        //   CREATEDBY: userInfo?.email_id,
        //   TaskStatus: nextNode,
        //   TaskROWID: res[0]?.insertId,
        //   TaskType: "Task",
        //   IsTransition: 0,
        //   UTCTimeString: convertToUSTime(new Date()),
        //   Comment: ""
        // }

        // AwsServerService.createTimeline(StatusTimelineEdgePayload).then(res => {
        //   AwsServerService.createTimeline(StatusTimelinePayload).then(res => {
        //     // refreshStatusTimeline(!statusTimeline);
        //   }).catch(e => {  })
        // }).catch(e => {  })
            // }
            if(duplicateObj.Subtask && data.SubTasks?.length > 0){
              await Promise.all(
                data.SubTasks.map((item) => {
                  delete item["id"];
                  delete item["flag"];
                  delete item["PipelineROWID"];
                  delete item["SubTaskROWID"];
                  delete item["TaskRowId"];
                  delete item["SubTaskId"];
                  delete item["SubTaskTemplateId"];
                  item["TaskROWID"] = res[0]?.insertId;
                  item["Status_Time"] =  moment.utc().format('YYYY-MM-DD HH:mm:ss');
                  item["TaskName"] = `${item["TaskName"]} - Copy`;
                  return SubTaskApiToCall(item);
                  // .then((ress) =>{
        //             let nextNode = item?.TaskFlowObject?.Nodes?.filter(res => res.id == "1")[0];
        //       let StatusTimelineEdgePayload = {
        //   CREATEDBY: userInfo?.email_id,
        //   TaskStatus: {data:{label: "Created", color: "#108ee9"},
        //               label : "Task Created",
        //               source : "0",
        //               target : "1",
        //               type : "custom-edge"},
        //   TaskROWID: ress[0]?.insertId,
        //   TaskType: "Sub-Task",
        //   IsTransition: 1,
        //   UTCTimeString: convertToUSTime(new Date()),
        //   Comment: ""
        // }
        // let StatusTimelinePayload = {
        //   CREATEDBY: userInfo?.email_id,
        //   TaskStatus: nextNode,
        //   TaskROWID: ress[0]?.insertId,
        //   TaskType: "Sub-Task",
        //   IsTransition: 0,
        //   UTCTimeString: convertToUSTime(new Date()),
        //   Comment: ""
        // }

        // AwsServerService.createTimeline(StatusTimelineEdgePayload).then(res => {
        //   AwsServerService.createTimeline(StatusTimelinePayload).then(res => {
        //     // refreshStatusTimeline(!statusTimeline);
        //   }).catch(e => {  })
        // }).catch(e => {   })
                  // }).catch((e) => {});
                })
              ).then((allRes) => {
                console.log("allRes dupl", allRes);
              });
            }
            setDuplicateValueObj({...defaultDuplicateObject})
            setPopUpType(null)
            DealName.current = dealSelected;
            setPageRefreshData(prev => !prev)
            setDuplicatePopUp(prev => !prev)
            setOpen(false)
            if(module == "bottomBar"){
              setSelectedIds({ Task: [], Subtask: [] });
            }
            setTaskData({...taskEmptyTemplate})
          })
      }

  const handleOnChangeDuplicateCheckBox = (e) => {
    const { name, checked } = e.target;
    const updatedObj = { ...duplicateValueObj };
    if (name === 'TaskName') {
        updatedObj[name] = e.target.value; // Handle TaskName input change
    } else if (name === 'Everything') {
      // Select/Deselect all checkboxes when 'Everything' is clicked
      const newValue = checked;
      Object.keys(updatedObj).forEach((key) => {
        if (key !== 'TaskName') {
          updatedObj[key] = newValue;
        }
      });
    } else {
      // Handle individual checkbox changes
      updatedObj[name] = checked;
    }
  
    // Check if all checkboxes (except 'TaskName' and 'Everything') are selected
    const allChecked = Object.keys(updatedObj).every(
      (key) => key === 'TaskName' || key === 'Everything' || updatedObj[key]
    );
  
    // Check if at least one checkbox (other than 'TaskName') is selected but not all
    const someChecked = Object.keys(updatedObj).some(
      (key) => key !== 'TaskName' && key !== 'Everything' && updatedObj[key]
    );
  
    // Update the 'Everything' checkbox state
    updatedObj['Everything'] = allChecked;
    setIndeterminate(someChecked && !allChecked); // Set indeterminate if some are checked but not all
  
    setDuplicateValueObj(updatedObj);
  };

  const renderDuplicateModal = (type) => {
    return (
    <AntModal
            title={popUpType ==  "Duplicate" ?"Duplicate Task" : "Save As Template"}
            open={duplicatePopUp}
            onCancel={()=>{setDuplicatePopUp(false); setPopUpType(null)}}
            footer={null}
            className="taskComplete-warning duplicate-task-modal"
          >
            <Row>
              <Col sm={12}>
                <h5 className='text-left'>{popUpType ==  "Duplicate" ?"New Task Name" : "Template Name"}</h5>
                <Input
                  onChange={(e)=>{
                    const trimmedValue = e.target.value.trimStart(); // Remove leading whitespace
                      e.target.value = trimmedValue;
    
                      if (trimmedValue) {
                        handleOnChangeDuplicateCheckBox(e);
                      }else{
                        e.target.value = '';
                        handleOnChangeDuplicateCheckBox(e);
                      }
                  }}
                  defaultValue={duplicateValueObj?.TaskName}
                  value={duplicateValueObj?.TaskName}
                  name='TaskName'
                  placeholder={popUpType ==  "Duplicate" ?"New Task Name" : "Template Name"}
                  className='form-control form-control-sm duplicate-taskname'
                />
              </Col>
            </Row>
      
            <div className='duplicate-task-box' style={{ padding: '20px 15px' }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <p style={{ fontSize: 16 }} className='small text-left'>
                  What do you want to copy?
                </p>
    
                <Checkbox
                  onChange={handleOnChangeDuplicateCheckBox}
                  checked={duplicateValueObj?.Everything}
                  indeterminate={indeterminate} // Add indeterminate state
                  name='Everything'
                  style={{width:"max-content"}}
                >
                  Everything
                </Checkbox>
    
                <Checkbox
                  onChange={handleOnChangeDuplicateCheckBox}
                  checked={duplicateValueObj?.Supervisor}
                  name='Supervisor'
                  style={{width:"max-content"}}
                >
                  Supervisor
                </Checkbox>
    
                <Checkbox
                  onChange={handleOnChangeDuplicateCheckBox}
                  checked={duplicateValueObj?.Assignee}
                  name='Assignee'
                  style={{width:"max-content"}}
                >
                  Assignee
                </Checkbox>
    
                <Checkbox
                  onChange={handleOnChangeDuplicateCheckBox}
                  checked={duplicateValueObj?.Priority}
                  name='Priority'
                  style={{width:"max-content"}}
                >
                  Priority
                </Checkbox>
    
                <Checkbox
                  onChange={handleOnChangeDuplicateCheckBox}
                  checked={duplicateValueObj?.TimeEstimate}
                  name='TimeEstimate'
                  style={{width:"max-content"}}
                >
                  Time Estimate
                </Checkbox>
    
                <Checkbox
                  onChange={handleOnChangeDuplicateCheckBox}
                  checked={duplicateValueObj?.StartDate}
                  name='StartDate'
                  style={{width:"max-content"}}
                >
                  Start Date
                </Checkbox>
    
                <Checkbox
                  onChange={handleOnChangeDuplicateCheckBox}
                  checked={duplicateValueObj?.DueDate}
                  name='DueDate'
                  style={{width:"max-content"}}
                >
                  Due Date
                </Checkbox>
                <Checkbox
                  onChange={handleOnChangeDuplicateCheckBox}
                  checked={duplicateValueObj?.Subtask}
                  name='Subtask'
                  style={{width:"max-content"}}
                >
                  Subtask
                </Checkbox>
              </div>
            </div>
      
            <Row>
              <Col sm={12} style={{ textAlign: 'right' }}>
                <Button
                  type='primary'
                  onClick={async () => {
                    if(duplicateValueObj?.TaskName){
                      hanleCreateDuplicateTask(duplicateValueObj, taskData)
                    }else{
                      swal('Alert',`${popUpType == "Duplicate" ? "Task" : "Template"} Name can not be empty!`,'warning');
                    }
                  }}
                >
                  {popUpType ==  "Duplicate" ?"Duplicate Task" : "Save Template"}
                </Button>
              </Col>
            </Row>
          </AntModal>
    )
  }
  return (
    <>
      {renderDuplicateModal(popUpType)}
      <Popover
        content={renderSettingsPopoverContent()}
        title=""
        trigger="click"
        open={popoverVisible}
        onOpenChange={setPopoverVisible}
        rootClassName="Duplicate-Modal"
      >
        {module == "bottomBar" ?
            <Button
              type="link"
              icon={<FontAwesomeIcon icon={faClone} opacity={0.5} />}
              disabled = {count > 1}
              onClick={()=>{
                handleOptionSelect({value:"Duplicate"})
              }}
            >
              Duplicate
            </Button> : item == undefined ? (
          <div
            className="SidebarBtns"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Button
              style={{ border: "none", height: "1.8rem", cursor: "pointer" }}
              icon={
                <img
                  src={SettingIconDark}
                  alt="SettingIcon"
                  style={{ width: "17px" }}
                />
              }
            />
            {/* <span>Settings</span> */}
          </div>
        ) : (
          <div
            className="mb-3 SidebarBtns"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Button style={{ border: "none" }} icon={item.icon} />
            <span>{item.key}</span>
          </div>
        )}
      </Popover>
    </>
  );
};

export default RenderSettingsPopoverContent;
